import { useTheme } from '@emotion/react';
import { Box, Button, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, Stack, StepConnector, stepConnectorClasses, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { addstore, editstore, getstore, getstoreProduct, getstorepurchase } from '../../../redux/slice/store.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Image_URL } from '../../../utils/baseURL';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, theme } = props;

    const icons = {
        1: <img src="/assets/images/icons/basicw.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
        2: <img src="/assets/images/icons/variant.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
        3: <img src="/assets/images/icons/tax.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className} onClick={onClick}>
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
};
const steps = ['Basic Details', 'Variant', 'Tax & Warrenty Details'];

const validationSchemas =
    Yup.object({
        multipleQty: Yup.array().of(
            Yup.object({
                recieveQtyforstore: Yup.string().required('Recieve Qty is required'),
                recieveunitPrice: Yup.string().required('Recieve Unit Price is required'),
            })
        ),
        storedate: Yup.date().required('store date is required'),
        Invoicenumber: Yup.string().required('Invoice Number is required'),
        Invoicedate: Yup.date().required('Invoice Date is required'),
        TransporterName: Yup.string().required('Transporter Name is required'),
        LRNumber: Yup.string().required('LR Number is required'),
        DriverName: Yup.string().required('Driver Name is required'),
        DriverContactNumber: Yup.string().required('Driver Contact Number is required'),
        VehicleNumber: Yup.string().required('Vehicle Number is required'),
        EwayBillNumber: Yup.string().required('Eway Bill Number is required'),
        Frieght: Yup.string().required('Frieght is required'),
        Remark: Yup.string().required('Remark is required'),
    });

const initialValues = {
    multipleQty: [{
        TotalQty: '',
        recieveQtyforstore: '',
        recieveQty: '',
        total: '',
        unitPrice: '',
        productName: '',
        recieveunitPrice: '',
        GSTAmount: '',
    }],
    storedate: '',
    warehouseId: '',
    Invoicenumber: '',
    Invoicedate: '',
    TransporterName: '',
    LRNumber: '',
    DriverName: '',
    DriverContactNumber: '',
    VehicleNumber: '',
    EwayBillNumber: '',
    Frieght: '',
    Remark: '',
    storeuploadFile: ''
};

const AddStore = () => {
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch()
    const [activeStep, setActiveStep] = React.useState(0);
    const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);
    const isLastStep = activeStep === steps.length - 1;
    const navigate = useNavigate()
    const imgUrl = Image_URL;
    const [multipleRecieve, setmultipleRecieve] = useState(initialValues.multipleQty)
    const { state } = useLocation()
    const id = state?.id;
    const statusL = state?.statusL;

    console.log("statusL", statusL);
    
    const productData = useSelector(state => state.store.products);
    const purchase = useSelector(state => state.store.purchase)?.find(v => v?._id == id);
    const store = useSelector(state => state.store.Store)?.find(st => st.purchase == id)
    const isMobile = useMediaQuery('(max-width:500px)');

    useEffect(() => {
        dispatch(getstorepurchase())
        dispatch(getstoreProduct())
        dispatch(getstore())
    }, [state])

    useEffect(() => {
        if (id && store) {
            setValues(store)
        }
    }, [id, store])

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => {
        setActiveStep(step);
    };

    const handleNext = (values, actions) => {
        setTouchedSteps((prevTouchedSteps) => {
            const newTouchedSteps = [...prevTouchedSteps];
            newTouchedSteps[activeStep] = true;
            return newTouchedSteps;
        });
        if (!isLastStep) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            actions.validateForm().then((errors) => {
                if (Object.keys(errors).length === 0) {
                    const submissionValues = {
                        ...values,
                        purchase: purchase._id,
                        status: 'Complete',
                        warehouseId: purchase.werehouse,
                        multipleQty: values.multipleQty.map((item, index) => {
                            const TotalQty = parseFloat(purchase.multipledata[index].Qty) || 0;
                            const recieveQtyforstore = parseFloat(item.recieveQty) || 0;
                            const recieveQty = recieveQtyforstore || 0;
                            const recieveunitPrice = parseFloat(item.recieveunitPrice) || 0;
                            const unitPrice = parseFloat(purchase.multipledata[index].unitPrice) || 0;
                            const GSTAmount = parseFloat(purchase.multipledata[index].gst) || 0;
                            const total = recieveQtyforstore * recieveunitPrice;
                            const productName = purchase.multipledata[index].productName;
                            return { ...item, total, productName, recieveunitPrice, GSTAmount, unitPrice, TotalQty, recieveQtyforstore, recieveQty };
                        }),
                    };
                    // console.log("Submission Values:", submissionValues);
                    if (values._id) {
                        delete submissionValues.isActive;
                        delete submissionValues.createdAt;
                        delete submissionValues.updatedAt;
                        dispatch(editstore({ id: values._id, ...submissionValues }));
                    } else {
                        dispatch(addstore(submissionValues));
                    }
                    actions.resetForm();
                    setActiveStep(0)
                } else {
                    alert('Please fix the errors in the form before submitting');
                }
                actions.setSubmitting(false);
            });
        }
    };
    const handleSubmit = () => {
        validationSchemas.validate(values, { abortEarly: false })
            .then(() => {
                const taxableAmount = values.multipleQty.reduce((acc, item, index) => acc + (item.recieveQtyforstore ? item.recieveQtyforstore * item.recieveunitPrice : 0), 0) || 0;
                const totalGstAmount = values.multipleQty.reduce((acc, item, index) => {
                    const gst = purchase?.multipledata?.[index]?.gst || 0;
                    const gstAmount = (parseFloat(item.recieveQtyforstore || 0) * parseFloat(item.recieveunitPrice || 0) * parseFloat(gst || 0)) / 100;
                    return acc + (isNaN(gstAmount) ? 0 : gstAmount);
                }, 0);
                const amountTotal = taxableAmount + totalGstAmount;
                console.log("taxableAmount", taxableAmount, "totalGstAmount", totalGstAmount, "amountTotal", amountTotal);
                const submissionValues = {
                    ...values,
                    purchase: purchase._id,
                    taxableAmount,
                    totalGstAmount,
                    amountTotal,
                    warehouseId: purchase.werehouse,
                    multipleQty: values.multipleQty.map((item, index) => {
                        const TotalQty = parseFloat(purchase.multipledata[index].Qty) || 0;
                        const recieveQtyforstore = parseFloat(item.recieveQtyforstore) || 0;
                        const recieveQty = recieveQtyforstore || 0;
                        const recieveunitPrice = parseFloat(item.recieveunitPrice) || 0;
                        const unitPrice = parseFloat(purchase.multipledata[index].unitPrice) || 0;
                        const GSTAmount = parseFloat(purchase.multipledata[index].gst) || 0;
                        const total = recieveQtyforstore * recieveunitPrice;
                        const productName = purchase.multipledata[index].productName;
                        return { ...item, total, productName, recieveunitPrice, GSTAmount, unitPrice, TotalQty, recieveQtyforstore, recieveQty };
                    }),
                };
                // console.log("submissionValues", submissionValues);
                if (values._id) {
                    dispatch(editstore({ id: values._id, ...submissionValues }))
                } else {
                    dispatch(addstore(submissionValues))
                }
                setActiveStep(0);
                navigate('/admin/pending-po');
                resetForm();
                setmultipleRecieve(initialValues.multipleQty);
            })
            .catch((validationErrors) => {
                console.log("Form validation errors:", validationErrors);
                alert("Please fill in all required fields before submitting.");
            });
    };

    const { handleBlur, handleChange, touched, setValues, errors, values, validateForm, setFieldValue, setFieldError, resetForm } = useFormik({
        initialValues: { ...initialValues, multipleQty: multipleRecieve },
        validationSchema: validationSchemas,
        onSubmit: handleNext,
    });

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [openView, setOpenView] = React.useState(false);
    const [viewImage, setViewImage] = useState(null);

    const handleView = (imageType) => {
        let imageUrl;

        if (imageType === 'storeuploadFile') {
            if (values.storeuploadFile instanceof File) {
                imageUrl = URL.createObjectURL(values.storeuploadFile);
            } else if (typeof values.storeuploadFile === 'string') {
                imageUrl = `${imgUrl}/${values.storeuploadFile}`;
            }
        }
        setViewImage(imageUrl);
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>

            {id ? (
                <Header
                    title="UPDATE STORE"
                    subtitle="Update Your Store Here"
                />
            ) : (
                <Header
                    title="ADD STORE"
                    subtitle="Manage Your Store Here"
                />
            )}
            <form onSubmit={handleSubmit} >
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    <TableContainer TableContainer sx={{ marginTop: 2 }}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#293754' }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>SR. NO.</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>PRODUCT NAME</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>DESCRIPTION</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>HSN CODE</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>QTY.</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>RECEIVE  QTY.</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>UNIT PRICE</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>RECEIVE UNIT PRICE</TableCell>
                                    <TableCell sx={{ color: 'white', fontSize: '14px' }}>TOTAL</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {purchase?.multipledata?.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>{productData?.find((p) => p._id === item.productName)?.productName || 'N/A'}</TableCell>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>{productData?.find((p) => p._id === item.productName)?.Desacription || 'N/A'}</TableCell>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>{productData?.find((p) => p._id === item.productName)?.HSNcode || 'N/A'}</TableCell>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>{item.Qty}</TableCell>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>
                                            <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                <TextField
                                                    fullWidth
                                                    variant="filled"
                                                    type="text"
                                                    label="Receive  Qty :"
                                                    onBlur={handleBlur}
                                                    onChange={e => {
                                                        const inputQty = parseFloat(e.target.value) || 0;
                                                        if (inputQty <= item.Qty) {
                                                            setFieldValue(`multipleQty[${index}].recieveQtyforstore`, inputQty);
                                                        } else {
                                                            setFieldError(`multipleQty[${index}].recieveQtyforstore`, `Cannot add more than available quantity of ${item.Qty}`);
                                                        }
                                                    }}
                                                    value={values.multipleQty?.[index]?.recieveQtyforstore || 0}
                                                    name={`multipleQty.${index}.recieveQtyforstore`}
                                                    error={!!errors.multipleQty?.[index]?.recieveQtyforstore}
                                                    helperText={errors.multipleQty?.[index]?.recieveQtyforstore}
                                                    sx={{ gridColumn: "span 2" }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>Rs. {purchase.multipledata[index].unitPrice}</TableCell>
                                        <TableCell>
                                            <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                <TextField
                                                    fullWidth
                                                    variant="filled"
                                                    type="text"
                                                    label="Receive Unit Price :"
                                                    onBlur={handleBlur}
                                                    // onChange={(e) => {
                                                    //     const inputrecieveunitPrice = e.target.value; // Keep the raw input as a string
                                                    //     const parsedValue = parseFloat(inputrecieveunitPrice); // Attempt to parse it as a float

                                                    //     if (!isNaN(parsedValue) && parsedValue <= item.unitPrice) {
                                                    //         setFieldValue(`multipleQty[${index}].recieveunitPrice`, inputrecieveunitPrice);
                                                    //     } else if (!isNaN(parsedValue)) {
                                                    //         setFieldError(
                                                    //             `multipleQty[${index}].recieveunitPrice`,
                                                    //             `Cannot add more than available UnitPrice of ${item.unitPrice}`
                                                    //         );
                                                    //     } else {
                                                    //         setFieldValue(`multipleQty[${index}].recieveunitPrice`, inputrecieveunitPrice); // Allow intermediate states
                                                    //     }
                                                    // }}
                                                    onChange={(e) => {
                                                        const inputrecieveunitPrice = e.target.value;
                                                        const parsedValue = parseFloat(inputrecieveunitPrice);

                                                        if (!isNaN(parsedValue) && parsedValue <= item.unitPrice) {
                                                            setFieldValue(`multipleQty[${index}].recieveunitPrice`, inputrecieveunitPrice);
                                                        } else if (!isNaN(parsedValue)) {
                                                            setFieldError(
                                                                `multipleQty[${index}].recieveunitPrice`,
                                                                `Cannot add more than available UnitPrice of ${item.unitPrice}`
                                                            );
                                                        } else {
                                                            setFieldValue(`multipleQty[${index}].recieveunitPrice`, inputrecieveunitPrice);
                                                        }
                                                    }}
                                                    value={values.multipleQty?.[index]?.recieveunitPrice}
                                                    name={`multipleQty.${index}.recieveunitPrice`}
                                                    error={!!errors.multipleQty?.[index]?.recieveunitPrice}
                                                    helperText={errors.multipleQty?.[index]?.recieveunitPrice}
                                                    sx={{ gridColumn: "span 2" }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: '600', fontSize: '14px' }}>
                                            Rs. {(() => {
                                                const recieveQtyforstore = parseFloat(values.multipleQty?.[index]?.recieveQtyforstore) || 0;
                                                const recieveunitPrice = parseFloat(values.multipleQty?.[index]?.recieveunitPrice) || 0;
                                                const total = recieveQtyforstore * recieveunitPrice;
                                                return isNaN(total) ? '0' : total;
                                            })()}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" }, marginTop: 3,
                        }}>
                        <Grid item xs={6} md={4}>
                            <TableContainer>
                                <Table sx={{ '& td, & th': { border: '1px solid #1A2B4F' } }}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: '600' }}><strong>Total Amount :</strong></TableCell>
                                            <TableCell align="right" sx={{ fontWeight: '600' }}>
                                                Rs. {(() => {
                                                    const totalAmount = values.multipleQty.reduce((acc, item) => {
                                                        const recieveQty = parseFloat(item.recieveQtyforstore) || 0;
                                                        const recieveunitPrice = parseFloat(item.recieveunitPrice) || 0;
                                                        return acc + (recieveQty * recieveunitPrice);
                                                    }, 0);
                                                    return totalAmount % 1 === 0 ? totalAmount.toFixed(0) : totalAmount.toFixed(2);
                                                })()}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: '600' }}><strong>Total GST Amount :</strong></TableCell>
                                            <TableCell align="right" sx={{ fontWeight: '600' }}>
                                                Rs. {(() => {
                                                    const totalGst = values.multipleQty.reduce((acc, item, index) => {
                                                        const gst = purchase?.multipledata?.[index]?.gst || 0;
                                                        const gstAmount = (parseFloat(item.recieveQtyforstore || 0) * parseFloat(item.recieveunitPrice || 0) * parseFloat(gst || 0)) / 100;
                                                        return acc + (isNaN(gstAmount) ? 0 : gstAmount);
                                                    }, 0);
                                                    return totalGst % 1 === 0 ? `${totalGst}` : `${totalGst.toFixed(2)}`;
                                                })()}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: '700' }}><strong>TOTAL :</strong></TableCell>
                                            <TableCell align="right" sx={{ fontWeight: '700' }}>
                                                Rs. {
                                                    (() => {
                                                        const totalAmount = Number(values.multipleQty.reduce((acc, item, index) => acc + (item.recieveQtyforstore ? item.recieveQtyforstore * item.recieveunitPrice : 0), 0) || 0);
                                                        const totalGst = Number(values.multipleQty.reduce((acc, item, index) => {
                                                            const gst = purchase?.multipledata?.[index]?.gst || 0;
                                                            const gstAmount = (parseFloat(item.recieveQtyforstore || 0) * parseFloat(item.recieveunitPrice || 0) * parseFloat(gst || 0)) / 100;
                                                            return acc + (isNaN(gstAmount) ? 0 : gstAmount);
                                                        }, 0));
                                                        const finalAmount = totalAmount + totalGst;

                                                        return finalAmount % 1 === 0 ? finalAmount.toFixed(0) : finalAmount.toFixed(2);
                                                    })()
                                                }
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Box>

                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" }, marginTop: 3
                        }}>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.storedate}
                                name="storedate"
                                error={!!touched.storedate && !!errors.storedate}
                                helperText={touched.storedate && errors.storedate}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Invoice Number:"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.Invoicenumber}
                                name="Invoicenumber"
                                error={!!touched.Invoicenumber && !!errors.Invoicenumber}
                                helperText={touched.Invoicenumber && errors.Invoicenumber}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Invoice Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.Invoicedate}
                                name="Invoicedate"
                                error={!!touched.Invoicedate && !!errors.Invoicedate}
                                helperText={touched.Invoicedate && errors.Invoicedate}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>

                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" }, marginTop: 3
                        }}>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Transporter Name :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.TransporterName}
                                name="TransporterName"
                                error={!!touched.TransporterName && !!errors.TransporterName}
                                helperText={touched.TransporterName && errors.TransporterName}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="LR Number:"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.LRNumber}
                                name="LRNumber"
                                error={!!touched.LRNumber && !!errors.LRNumber}
                                helperText={touched.LRNumber && errors.LRNumber}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Driver Name :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.DriverName}
                                name="DriverName"
                                error={!!touched.DriverName && !!errors.DriverName}
                                helperText={touched.DriverName && errors.DriverName}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>

                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" }, marginTop: 3
                        }}>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Driver Contact Number :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.DriverContactNumber}
                                name="DriverContactNumber"
                                error={!!touched.DriverContactNumber && !!errors.DriverContactNumber}
                                helperText={touched.DriverContactNumber && errors.DriverContactNumber}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Vehicle Number:"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.VehicleNumber}
                                name="VehicleNumber"
                                error={!!touched.VehicleNumber && !!errors.VehicleNumber}
                                helperText={touched.VehicleNumber && errors.VehicleNumber}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Eway Bill Number :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.EwayBillNumber}
                                name="EwayBillNumber"
                                error={!!touched.EwayBillNumber && !!errors.EwayBillNumber}
                                helperText={touched.EwayBillNumber && errors.EwayBillNumber}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>

                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" }, marginTop: 3
                        }}>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Frieght :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.Frieght}
                                name="Frieght"
                                error={!!touched.Frieght && !!errors.Frieght}
                                helperText={touched.Frieght && errors.Frieght}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Remark:"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.Remark}
                                name="Remark"
                                error={!!touched.Remark && !!errors.Remark}
                                helperText={touched.Remark && errors.Remark}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                            <Button
                                variant="contained"
                                component="label"
                            >
                                Store Upload File
                                <input
                                    type="file"
                                    hidden
                                    id="storeuploadFile"
                                    name="storeuploadFile"
                                    onChange={(event) => {
                                        setFieldValue("storeuploadFile", event.currentTarget.files[0]);
                                    }}
                                    onBlur={handleBlur}
                                />
                            </Button>

                            {values.storeuploadFile && (
                                typeof values.storeuploadFile === 'string' ? (
                                    values.storeuploadFile.toLowerCase().endsWith('.pdf') ? (
                                        <iframe
                                            src={`${imgUrl}/${values.storeuploadFile}`}
                                            style={{ width: '50px', height: '50px', border: 'none' }}
                                            title="PDF Preview"
                                        />
                                    ) : (<img
                                        src={`${imgUrl}/${values.storeuploadFile}`}
                                        style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                        alt="Uploaded Preview"
                                    />)
                                ) : (
                                    values.storeuploadFile.type.startsWith('image/') ? (
                                        <img
                                            src={URL.createObjectURL(values.storeuploadFile)}
                                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                            alt="Uploaded Preview"
                                        />
                                    ) : (
                                        <iframe
                                            src={URL.createObjectURL(values.storeuploadFile)}
                                            style={{ width: '50px', height: '50px', border: 'none' }}
                                            title="PDF Preview"
                                        />
                                    )
                                )
                            )}
                            <IconButton aria-label="edit"
                                onClick={() => handleView('storeuploadFile')}
                            >
                                <RemoveRedEyeIcon />
                            </IconButton>
                        </div>
                    </Box>

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    handleSubmit();
                                }}
                                disabled={statusL}
                            >
                                {id ? 'Update' : 'Save'}
                            </Button>
                        </Stack>
                    </FormControl>

                    <Dialog
                        fullScreen={fullScreen}
                        open={openView}
                        onClose={handleCloseView}
                        aria-labelledby="responsive-dialog-title"
                        maxWidth={"sm"}
                        fullWidth
                    >
                        <DialogContent style={{ backgroundColor: theme.palette.background.purple, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            {viewImage ? (
                                values.storeuploadFile instanceof File && values.storeuploadFile.type === 'application/pdf' ||
                                    (typeof values.storeuploadFile === 'string' && values.storeuploadFile.toLowerCase().endsWith('.pdf')) ? (
                                    <iframe
                                        src={viewImage}
                                        style={{ width: '800px', height: '80vh', border: 'none' }}
                                        title="PDF Preview"
                                    />
                                ) : (
                                    <div style={{ maxWidth: '100%', maxHeight: '80vh' }}>
                                        <img
                                            src={viewImage}
                                            alt="Uploaded File"
                                            style={{ width: '700px', height: '80vh', objectFit: 'contain' }}
                                        />
                                    </div>
                                )
                            ) : (
                                <p>No file to display</p>
                            )}
                        </DialogContent>
                        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                            <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Stack>
            </form>
        </Box >
    )
}

export default AddStore